export default class {

    constructor() {
        $(window).on('scroll', function() {
            if ($(this).scrollTop() >= 152) {
                $('#header-wrapper').addClass('stick');
            } else {
                $('#header-wrapper').removeClass('stick');
            }
        });
    }

}


// WEBPACK FOOTER //
// ./resources/js/src/core/Header.js